import React, { useState } from 'react';
import { BsCpu } from 'react-icons/bs';
import {
  Box,
  Button,
  Icon,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
  Tooltip,
  VStack
} from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import PropTypes from 'prop-types';

import UseFormMethodsType from '../../../types/UseFormMethodsType';

const PinsAiSuggestion = ({ inputName, useFormMethods, suggestions = [] }) => {
  const { setValue } = useFormMethods;
  const [butonPulse, setButtonPulse] = useState(true);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
  });

  const pulse = keyframes`
    0% {transform: scale(1,1);}
    50% {opacity: 0.5;}
    100% {transform: scale(1.5); opacity: 0.3;}
  `;

  return (
    <Popover
      placement="left-end"
      onOpen={() => setButtonPulse(false)}
    >
      <PopoverTrigger>
        <Box mr={4}>
          <Tooltip hasArrow shouldWrapChildren colorScheme="brand" label="PINS AI Suggestion" placement="top">
            <IconButton
              animation={butonPulse ? `${pulse} 1s ease infinite` : undefined}
              aria-label="PINS AI Suggestion Button"
              icon={<Icon as={BsCpu} />}
              size="sm"
            />
          </Tooltip>
        </Box>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>
          <Box mb={4} mt={6}>
            <Text>PINS thinks the limit is one of the following.</Text>
            <Text mb={4}>Select the correct limit to apply it.</Text>
            <VStack>
              {suggestions.map(sug => {
                const value = formatter.format(sug);

                return (
                  <Button
                    key={`suggested_value_${sug}`}
                    size="xs"
                    variant="secondary"
                    onClick={() => setValue(inputName, sug)}
                  >
                    {value}
                  </Button>
                );
              })}
            </VStack>
          </Box>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

PinsAiSuggestion.propTypes = {
  inputName: PropTypes.string.isRequired,
  useFormMethods: UseFormMethodsType,
  suggestions: PropTypes.arrayOf(PropTypes.number)
};

export default PinsAiSuggestion;
